<template>
  <nav
    :class="[
      'transition-[background-color_height_translateY] ease-linear h-22.5 overflow-hidden lg:hidden',
      {
        'h-[100dvh] grid grid-rows-[max-content_1fr]': open,
        '-translate-y-full': !open && collapsed,
        'bg-dustrose': open || (!transparent && !collapsed),
      },
    ]"
  >
    <div class="flex items-center justify-between gap-2.5 p-5">
      <LangRouterLink :to="{ name: $routes.HOME }">
        <img :src="logo" alt="" class="w-25" />
      </LangRouterLink>
      <div class="flex items-center gap-2.5">
        <BookingLink />
        <MenuToggle :open="open" @click.stop="toggleOpen" :dark="!transparent" />
      </div>
    </div>
    <div class="overflow-auto">
      <div class="p-5">
        <CardLink />
      </div>
      <ul>
        <li v-for="(link, linkIndex) in links" :key="`mobile-nav-link-${linkIndex}`" class="group">
          <SiteLink
            :content="link"
            class="py-5.5 px-8 border-t border-pink block uppercase group-last-of-type:border-b text-sm"
          />
        </li>
      </ul>
      <div class="py-5 px-8">
        <LangSwitch />
      </div>
      <div class="p-5">
        <div class="bg-burgundy p-2.5">
          <SiteAddress
            class="bg-burgundy text-dustrose [&_.font-title]:text-pink w-full border border-pink"
          />
        </div>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import { type PropType, toRef } from 'vue'

import SiteAddress from '@/components/blocks/SiteAddress.vue'
import IconSprite from '@/components/helpers/IconSprite.vue'
import LangRouterLink from '@/components/helpers/LangRouterLink.vue'
import SiteLink from '@/components/helpers/SiteLink.vue'
import BookingLink from '@/components/navigation/small/BookingLink.vue'
import CardLink from '@/components/navigation/small/CardLink.vue'
import LangSwitch from '@/components/navigation/small/LangSwitch.vue'
import MenuToggle from '@/components/navigation/small/MenuToggle.vue'
import { useNavigation } from '@/composables/useNavigation.ts'

export default {
  name: 'MobileNavigation',
  components: {
    BookingLink,
    CardLink,
    IconSprite,
    LangRouterLink,
    LangSwitch,
    MenuToggle,
    SiteAddress,
    SiteLink,
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
    links: {
      type: Array as PropType<Link[]>,
      required: true,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { logo, open, toggleOpen } = useNavigation(toRef(props, 'transparent'))

    return { logo, open, toggleOpen }
  },
}
</script>
